import { useState } from "react";
const host = process.env.REACT_APP_SERVER;

const CreateGoogleSheetButton = ({ projectId, projectData, active }) => {
  const [loading, setLoading] = useState(false);
  const [sheetUrl, setSheetUrl] = useState("");

  const fetchLikedNames = async () => {
    try {
      const response = await fetch(`${host}/api/projects/${projectId}/get-liked-names`);
      if (response.ok) {
        const data = await response.json();
        return data.likedNames;
      } else {
        console.error("Failed to fetch liked names");
      }
    } catch (error) {
      console.error("Error fetching liked names:", error);
    }
  };

  const handleCreateSheet = async () => {
    setLoading(true);

    try {
      // Fetch liked names when the button is pressed
      let likedNames = await fetchLikedNames();
      // Format the data for Google Sheets
      const values = [
        [
          "Name",
          "TM",
          "Jack",
          "Mark",
          "Rationale",
          "Comments",
          "Google check",
          "Registered conflict",
          "Similarity",
          "Country",
          "Classes",
        ],
      ];

      likedNames.forEach(name => {
        values.push([name.name, name.trademark || "TBD", "TBD", "TBD", "", "", "TBD", "", "", "", ""]);

        let conflicts = name.conflicts;

        // Handle the case where conflicts might be a stringified JSON
        if (typeof conflicts === "string" && conflicts.startsWith("[") && conflicts.endsWith("]")) {
          try {
            conflicts = JSON.parse(conflicts);
          } catch (e) {
            console.error("Failed to parse conflicts string:", e);
            conflicts = [];
          }
        }

        // Now check if it's an array with content
        if (Array.isArray(conflicts) && conflicts.length > 0) {
          conflicts.slice(0, 20).forEach(c => {
            // Make sure we're accessing properties safely
            values.push([
              "", // Placeholder for first column
              "", // Placeholder for second column
              "", // Placeholder for third column
              "", // Placeholder for fourth column
              "", // Placeholder for fifth column
              "", // Placeholder for sixth column
              "", // Placeholder for seventh column
              c.name ? c.name : "", // Name if available, otherwise empty string
              c.similarity_to_query ? c.similarity_to_query.toFixed(2) : "", // Safely handle similarity
              c.country_code ? c.country_code : "", // Safely handle country code
              c.classes && Array.isArray(c.classes) ? c.classes.join(", ") : "", // Safely handle classes
            ]);
          });
        }

        values.push([""]);
      });

      let emails = ["chris@satori-ai.com"];
      const response = await fetch(`${host}/api/create-google-sheet`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ values, emails, projectName: projectData.name }), // Send formatted values and email in the request body
      });

      if (response.ok) {
        const result = await response.json();
        setSheetUrl(result.sheetUrl); // Assuming the backend returns the URL of the created sheet
      } else {
        console.error("Failed to create Google Sheet");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2">
      <button
        className="w-full flex items-center justify-center gap-2 px-5 py-2.5 bg-primary text-primary-content rounded-full hover:brightness-110 transition-all text-sm font-medium uppercase tracking-wider disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleCreateSheet}
        disabled={!active || loading}
      >
        {loading ? "Creating..." : "Export to Google Sheets"}
      </button>
      {sheetUrl && (
        <a
          href={sheetUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="block text-center text-xs text-primary hover:underline"
        >
          Open Google Sheet →
        </a>
      )}
    </div>
  );
};

export default CreateGoogleSheetButton;
